module.exports = __webpack_public_path__ + "img/4.22fadd65.png";